import { apiClient, withoutAuth } from './client';
import type {
  LoginEmailRequest,
  LoginResponse,
  LogoutRequest,
  MeResponse,
  RefreshRequest,
  RefreshResponse,
} from './auth.types';

/**
 * Endpoints `/api/v1/auth/` — Phase 1.
 * Tous les payloads sont typés manuellement en attendant `pnpm gen:api`.
 */

export async function login(email: string, password: string): Promise<LoginResponse> {
  const payload: LoginEmailRequest = { email, password, audience: 'staff' };
  const { data } = await apiClient.post<LoginResponse>(
    '/auth/login/email',
    payload,
    withoutAuth(),
  );
  return data;
}

export async function refresh(refreshToken: string): Promise<RefreshResponse> {
  const payload: RefreshRequest = { refresh: refreshToken };
  const { data } = await apiClient.post<RefreshResponse>(
    '/auth/refresh',
    payload,
    withoutAuth(),
  );
  return data;
}

export async function logout(refreshToken: string): Promise<void> {
  const payload: LogoutRequest = { refresh: refreshToken };
  await apiClient.post<void>('/auth/logout', payload);
}

export async function me(): Promise<MeResponse> {
  const { data } = await apiClient.get<MeResponse>('/auth/me');
  return data;
}
